import { render, staticRenderFns } from "./FiscalProductInfo.vue?vue&type=template&id=5f6b3d5d&scoped=true&"
import script from "./FiscalProductInfo.vue?vue&type=script&lang=js&"
export * from "./FiscalProductInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f6b3d5d",
  null
  
)

export default component.exports